import React from 'react';
import Layout from '../components/Layout';
import ReportDemo from '../components/ReportDemo';

const ReportDemoPage: React.FC = () => {
  return (
    <Layout>
      <ReportDemo />
    </Layout>
  );
};

export default ReportDemoPage;
